<div class="flex flex-row justify-between items-center">
  <h1 class="app-ellipsis">
    {{ '+COMMISSIONING.DEVICE.FLOOR_HEATING_THERMOSTAT' | translate }}
  </h1>
  <button
    mat-icon-button
    class="edit-icon"
    gtm="onClose"
    gtmCategory="fhtManager"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<app-floor-heating-thermostat-manager class="manager"></app-floor-heating-thermostat-manager>
